var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet-add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 1757",
    d: "M14.501 15.8755H9.50098",
    stroke: "#13D19D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1758",
    d: "M12.001 13.5925V18.5925",
    stroke: "#13D19D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1759",
    d: "M12.2811 2.24854L12.2511 2.31854L9.35105 9.04854H6.50105C5.84137 9.04838 5.1884 9.18101 4.58105 9.43854L6.33105 5.25854L6.37105 5.15854L6.44105 4.99854C6.45828 4.93955 6.48175 4.88256 6.51105 4.82854C7.82105 1.79854 9.30105 1.10854 12.2811 2.24854Z",
    stroke: "#13D19D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1760",
    d: "M18.8479 9.24954C18.3905 9.11255 17.9152 9.04513 17.4379 9.04954H10.5269L13.4269 2.31954L13.4569 2.24954C13.6069 2.29954 13.7469 2.36954 13.8969 2.42954L16.1069 3.35954C17.0998 3.70055 17.9953 4.27699 18.7169 5.03954C18.8124 5.15056 18.8962 5.27121 18.9669 5.39954C19.0556 5.53155 19.1231 5.67664 19.1669 5.82954C19.2042 5.91349 19.2343 6.00047 19.2569 6.08954C19.4903 7.15847 19.3457 8.27526 18.8479 9.24954Z",
    stroke: "#13D19D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1761",
    d: "M22.9998 14.4696V16.4196C22.9998 16.6196 22.9888 16.8196 22.9768 17.0196C22.7628 20.5076 20.5658 22.2696 16.3998 22.2696H7.59984C7.33243 22.2682 7.06533 22.2515 6.79984 22.2196C3.21584 22.0096 1.3035 20.3129 1.06284 17.1296C1.027 16.8946 1.00828 16.6573 1.00684 16.4196V14.4696C1.04103 13.4709 1.37855 12.5063 1.9745 11.7042C2.57044 10.9021 3.39654 10.3005 4.34284 9.97955C5.03517 9.72166 5.76803 9.58958 6.50684 9.58955H17.5068C18.0428 9.58846 18.5768 9.65567 19.0958 9.78955C20.1702 10.0326 21.1347 10.6226 21.8403 11.4685C22.5459 12.3143 22.9534 13.369 22.9998 14.4696Z",
    stroke: "#13D19D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1762",
    d: "M5.71 6.04953L3.96 10.2295C3.0818 10.6073 2.33348 11.2341 1.80745 12.0324C1.28142 12.8306 1.00072 13.7655 1 14.7215V11.7915C0.998851 10.4371 1.46778 9.12428 2.32676 8.07709C3.18574 7.02991 4.38151 6.31328 5.71 6.04953Z",
    stroke: "#13D19D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1763",
    d: "M22.9971 11.8725V14.8045C22.9975 13.758 22.6614 12.739 22.0384 11.8981C21.4153 11.0572 20.5384 10.4389 19.5371 10.1345C20.0277 9.15456 20.1755 8.03843 19.9571 6.96453C19.9377 6.87455 19.9075 6.78725 19.8671 6.70453C20.8117 7.19722 21.6029 7.93958 22.1548 8.85081C22.7067 9.76204 22.998 10.8072 22.9971 11.8725Z",
    stroke: "#13D19D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletAdd);
export default __webpack_public_path__ + "static/media/wallet-add.7320c86013b465c22368115bd59ec75a.svg";
export { ForwardRef as ReactComponent };